// Mesaj şablonu ayarları ve paylaşım kaydı (ağ istekleri). Saf biçimlendirme: utils/offerShare.js.
// Not: Authorization başlığını AuthContext'teki genel fetch sarmalayıcısı ekler; yine de token verilirse kullanılır.
import { API_URL, jsonAuthHeaders } from './api';

// settings 'messages' → {} (kayıt yoksa ya da alınamazsa: şablonlar varsayılana düşer, paylaşım yine çalışır)
export const fetchMessageSettings = async () => {
  try {
    const res = await fetch(`${API_URL}/settings/messages`);
    if (!res.ok) return {};
    const data = await res.json();
    return data && typeof data === 'object' ? data : {};
  } catch {
    return {};
  }
};

// Sunucuda PDF'i bulunan oda teklifi numaraları → Set. Alınamazsa null (bilinmiyor: uyarı gösterilmez, paylaşım engellenmez).
export const fetchOfferPdfIds = async () => {
  try {
    const res = await fetch(`${API_URL}/offers/pdfs`);
    if (!res.ok) return null;
    const data = await res.json();
    return Array.isArray(data?.ids) ? new Set(data.ids.map(Number)) : null;
  } catch {
    return null;
  }
};

// Paylaşmadan önce: PDF'i olmayan teklifin linki müşteriye "bağlantınız güncellendi" sayfası açar.
// pdfIds null ise (bilinmiyor) ya da PDF varsa true; yoksa kullanıcıya sorar.
export const confirmPdfBeforeShare = (offer, pdfIds) => {
  if (!pdfIds || !offer?.id || pdfIds.has(Number(offer.id))) return true;
  return window.confirm(
    `${offer.customerName || 'Bu teklif'} için sunucuda PDF yok: müşteri linki açınca teklif yerine "bağlantınız güncellendi" sayfasını görür.\n\n`
    + 'Önce teklifi açıp "Güncelle" ile kaydedin (PDF oluşur). Yine de gönderilsin mi?'
  );
};

// "Teklif Gönderildi" işlem kaydı (bilgi amaçlı; hata paylaşımı engellemez). channel: 'WhatsApp (detaylı)' vb.
export const logOfferShare = (offer, channel, token) => {
  if (!offer?.id) return;
  fetch(`${API_URL}/activityLogs`, {
    method: 'POST',
    headers: jsonAuthHeaders(token),
    body: JSON.stringify({
      action: 'Teklif Gönderildi',
      description: `${offer.customerName || 'Müşteri'} (#${offer.id}) teklifi gönderildi: ${channel}.`,
    }),
  }).catch(() => {});
};
